import * as yup from "yup"
import libphonenumber from "google-libphonenumber"

export const authenticationValidationSchema = (t) => {
  return yup.object().shape({
    "phone-prefix": yup
      .object()
      .shape({
        value: yup.string(),
        label: yup.string(),
        imagePath: yup.string(),
      })
      .required(t("errors.field-required")),
    "phone-number": yup
      .string()
      .required(t("errors.field-required"))
      .test("is-valid-phone", t("errors.phone-number"), function (value) {
        const prefix = this.parent["phone-prefix"].value
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
        try {
          const phone = phoneUtil.parse(`${prefix}${value}`)
          return phoneUtil.isValidNumberForRegion(
            phone,
            phoneUtil.getRegionCodeForNumber(phone)
          )
        } catch (err) {
          return false
        }
      }),
  })
}

export const confirmPhoneNumberValidationSchema = (t) => {
  return yup.object().shape({
    code: yup.string().min(4).max(4).isRequired(t("errors.field-required")),
  })
}

const phoneNumberValidation = (t, index) =>
  yup.string().test({
    message: t("errors.phone-number"),
    test: function (value) {
      const prefix = this.parent[`phone-prefix-${index}`]?.value

      if (this.parent[`phone-number-${index}`] !== undefined) {
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
        try {
          const phone = phoneUtil.parse(`${prefix}${value}`)
          return phoneUtil.isValidNumberForRegion(
            phone,
            phoneUtil.getRegionCodeForNumber(phone)
          )
        } catch (err) {
          return false
        }
      }
      return true
    },
  })

export const profileValidationSchema = (t, phoneNumberCount) => {
  const phoneNumberValidations = Array.from(
    { length: phoneNumberCount },
    (_, index) => ({
      [`phone-prefix-${index}`]: yup
        .object()
        .shape({
          value: yup.string(),
          label: yup.string(),
          imagePath: yup.string(),
        })
        .notRequired(),
      [`phone-number-${index}`]: phoneNumberValidation(t, index),
    })
  )

  return yup.object().shape({
    "first-name": yup.string().notRequired(),
    "last-name": yup.string().notRequired(),
    email: yup.string().email(t("errors.email")).notRequired(),
    ...Object.assign({}, ...phoneNumberValidations),
  })
}

export const fileEditValidationSchema = (t) => {
  return yup.object().shape({
    "file-name": yup.string().required(t("errors.field-required")),
  })
}

export const userConfirmationValidationSchema = (t) => {
  return yup.object().shape({
    "phone-prefix": yup
      .object()
      .shape({
        value: yup.string(),
        label: yup.string(),
        imagePath: yup.string(),
      })
      .required(t("errors.field-required")),
    "phone-number": yup
      .string()
      .required(t("errors.field-required"))
      .test("is-valid-phone", t("errors.phone-number"), function (value) {
        const prefix = this.parent["phone-prefix"].value

        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
        try {
          const phone = phoneUtil.parse(`${prefix}${value}`)
          return phoneUtil.isValidNumberForRegion(
            phone,
            phoneUtil.getRegionCodeForNumber(phone)
          )
        } catch (err) {
          return false
        }
      }),
    email: yup
      .string()
      .email(t("errors.email"))
      .required(t("errors.field-required")),
    name: yup.string().required(t("erros.field-required")),
  })
}

export const mortgageValidationSchema = (t) => {
  return yup.object().shape({
    type: yup
      .string()
      .oneOf(["fixed", "variable"])
      .required(t("errors.field-required")),
    rate: yup.number().min(0).max(50).required(t("errors.field-required")),
    provider: yup.string().required(t("errors.field-required")),
    currentValue: yup.number().min(0).required(t("errors.field-required")),
  })
}

export const secSysValidationSchema = (t) => {
  return yup.object().shape({
    buildingSecurity: yup.string().required(t("errors.field-required")),
    alarm: yup.string().required(t("errors.field-required")),
    cctv: yup.string().required(t("errors.field-required")),
    other: yup.string().required(t("errors.field-required")),
  })
}

export const secAccValidationSchema = (t) => {
  return yup.object().shape({
    securityDoor: yup.string().required(t("errors.field-required")),
    blinds: yup.string().required(t("errors.field-required")),
    windowGlazing: yup.string().required(t("errors.field-required")),
    windowBars: yup.string().required(t("errors.field-required")),
    other: yup.string().required(t("errors.field-required")),
  })
}
